import { OvlAddDialog } from "../../../../_ovlclient/src/global/globals"
import { SYSEditorAsset } from "./assetconfig"

export const SYSEditorAsset_Init = () => {
  OvlAddDialog(SYSEditorAsset, "SYSEditorAsset")
}
